const toFiniteNumber = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

const trimTrailingZero = (value: string) => value.replace(/\.0$/, '');

export const formatDoseMg = (value: unknown, fallback = '-'): string => {
  const parsed = toFiniteNumber(value);
  return parsed == null ? fallback : String(Math.round(parsed));
};

export const formatDoseMgKg = (value: unknown, fallback = '-'): string => {
  const parsed = toFiniteNumber(value);
  return parsed == null ? fallback : trimTrailingZero(parsed.toFixed(1));
};

export const formatExposure = (value: unknown, fallback = '-'): string => {
  const parsed = toFiniteNumber(value);
  return parsed == null ? fallback : parsed.toFixed(1);
};

export const formatPercent = (value: unknown, fallback = '-'): string => {
  const parsed = toFiniteNumber(value);
  return parsed == null ? fallback : `${parsed.toFixed(1)}%`;
};
